import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const header = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  background-color: ${theme.surface.level1};

  color: ${theme.text.body};

  padding: 0.5rem 0;

  @media screen and (max-width: ${dimensions.phoneLargeMax}) {
    padding: 0.5rem 0;
  }
`;
